<template>
  <a href="javascript:void(0)" @click="onClick($event)">
    <slot />
  </a>
</template>

<script>
import {openSignupAndPreserveUrl} from "@/helpers";
export default {
  name: "LinkToSignup",
  methods: {
    onClick(ev) {
      openSignupAndPreserveUrl(ev);
    }
  }
}
</script>

<style scoped>

</style>
